import { createSlice } from "@reduxjs/toolkit";
import { IEvent, IEventType } from "components/Event";

export interface EventsState {
  isLoaded: boolean;
  events: IEvent[];
  eventTypes: IEventType[];
}

const eventSlice = createSlice({
  name: "events",
  initialState: { isLoaded: false, events: [], eventTypes: [] } as EventsState,
  reducers: {
    fetchEvents: (state, action) => {
      state.isLoaded = true;
      state.events = action.payload.events;
      state.eventTypes = action.payload.eventTypes;
    },
    addEvent: (state, action) => {
      state.events.unshift(action.payload);
    },
    invalidateEvents: (state) => {
      state.isLoaded = false;
    },
  },
});

export const { fetchEvents, addEvent, invalidateEvents } = eventSlice.actions;
export default eventSlice.reducer;
